var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58594 12.6002C4.3126 12.6002 4.08594 12.3735 4.08594 12.1002V10.7202C4.08594 10.4469 4.3126 10.2202 4.58594 10.2202C4.85927 10.2202 5.08594 10.4469 5.08594 10.7202V12.1002C5.08594 12.3802 4.85927 12.6002 4.58594 12.6002Z",
    fill: "#6461FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.6002C7.72667 12.6002 7.5 12.3735 7.5 12.1002V9.3335C7.5 9.06016 7.72667 8.8335 8 8.8335C8.27333 8.8335 8.5 9.06016 8.5 9.3335V12.1002C8.5 12.3802 8.27333 12.6002 8 12.6002Z",
    fill: "#6461FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4141 12.5998C11.1407 12.5998 10.9141 12.3731 10.9141 12.0998V7.95312C10.9141 7.67979 11.1407 7.45312 11.4141 7.45312C11.6874 7.45312 11.9141 7.67979 11.9141 7.95312V12.0998C11.9141 12.3798 11.6941 12.5998 11.4141 12.5998Z",
    fill: "#6461FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58574 8.78645C4.35907 8.78645 4.15907 8.63312 4.09907 8.40645C4.03241 8.13978 4.19241 7.86645 4.46574 7.79978C6.91907 7.18645 9.07907 5.84645 10.7257 3.93312L11.0324 3.57312C11.2124 3.36645 11.5257 3.33978 11.7391 3.51978C11.9457 3.69978 11.9724 4.01312 11.7924 4.22645L11.4857 4.58645C9.70574 6.66645 7.35907 8.11312 4.70574 8.77312C4.66574 8.78645 4.62574 8.78645 4.58574 8.78645Z",
    fill: "#6461FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4143 6.34657C11.1409 6.34657 10.9143 6.1199 10.9143 5.84657V4.3999H9.46094C9.1876 4.3999 8.96094 4.17324 8.96094 3.8999C8.96094 3.62657 9.1876 3.3999 9.46094 3.3999H11.4143C11.6876 3.3999 11.9143 3.62657 11.9143 3.8999V5.85324C11.9143 6.12657 11.6943 6.34657 11.4143 6.34657Z",
    fill: "#6461FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 15.1668H6.00065C2.38065 15.1668 0.833984 13.6202 0.833984 10.0002V6.00016C0.833984 2.38016 2.38065 0.833496 6.00065 0.833496H10.0007C13.6207 0.833496 15.1673 2.38016 15.1673 6.00016V10.0002C15.1673 13.6202 13.6207 15.1668 10.0007 15.1668ZM6.00065 1.8335C2.92732 1.8335 1.83398 2.92683 1.83398 6.00016V10.0002C1.83398 13.0735 2.92732 14.1668 6.00065 14.1668H10.0007C13.074 14.1668 14.1673 13.0735 14.1673 10.0002V6.00016C14.1673 2.92683 13.074 1.8335 10.0007 1.8335H6.00065Z",
    fill: "#6461FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusUp);
export default __webpack_public_path__ + "static/media/status-up.2b4a8843edb85b491d73a79953e4e3e6.svg";
export { ForwardRef as ReactComponent };